import classNames from 'classnames'
import React from 'react'
import {toast} from 'react-hot-toast'

import Icon, {Icons} from '../icons/Icon'
import {ToastBase, ToastBaseProps, ToastIconProps} from './types'

const showToast = ({message, type}: ToastBaseProps) => {
  toast.custom(t => <Toast toast={t} type={type} message={message} />,
    {
      position: 'bottom-center',
      duration: 5000
    })
}

const ToastIcon = ({type}: ToastIconProps) => {
  const icon: Icons = type === 'success' ? 'success' : 'error'
  return <Icon icon={icon} className="fill-white" />
}

const Toast = ({toast: t, message, type}: ToastBase) => {
  const iconBoxStyles = classNames('w-[48px] rounded-l-lg flex justify-center items-center', {
    'bg-kwota-alert-300': type === 'error',
    'bg-kwota-green-300': type === 'success',
    'bg-kwota-warning-300': type === 'info'
  })

  return (
    <div
      className={`${
        t.visible ? 'transition ease-out duration-500' : 'transition ease-in duration-500'
      } w-full bg-white shadow-lg rounded-lg pointer-events-auto flex min-h-[48px] max-w-[568px]`}
    >
      <div className={iconBoxStyles}>
        <ToastIcon type={type} />
      </div>
      <div className="flex-1 font-titillium text-base text-kwota-neutral-800 px-4 py-3">
        {message}
      </div>
      <div className="rounded-r-lg flex justify-center items-center p-4">
        <Icon icon="cross" size="sm" onClick={() => toast.dismiss(t.id)} />
      </div>
    </div>
  )
}

export default showToast
